export const TT_PROVIDER_LINK =
  'https://www.truckertools.com/eld-carrier-integration/?partner=loadsmart'

export const enum TrackingProvider {
  TT = 'trucker-tools',
  MACROPOINT = 'macropoint',
}

export const enum TrackingMethod {
  API = 'api',
  EDI = 'edi',
  ELD = 'eld',
  Manual = 'manual',
  Mobile = 'mobile',
}

export const ALL_TRACKING_PROVIDERS = [
  TrackingMethod.ELD,
  TrackingMethod.EDI,
  TrackingMethod.API,
  TrackingMethod.Mobile,
  TrackingMethod.Manual,
]
